import { render, staticRenderFns } from "./visualDigitalFactory.vue?vue&type=template&id=d80b4d88&scoped=true"
import script from "./visualDigitalFactory.vue?vue&type=script&lang=js"
export * from "./visualDigitalFactory.vue?vue&type=script&lang=js"
import style0 from "./visualDigitalFactory.vue?vue&type=style&index=0&id=d80b4d88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80b4d88",
  null
  
)

export default component.exports